import React from "react";
import Fade from "react-reveal/Fade";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { LifeAtSalaamCertification2026Data } from "../../../Data/Data";

SwiperCore.use([Autoplay, Pagination]);

const Certification2026 = () => {
  const items = LifeAtSalaamCertification2026Data || [];

  return (
    <div className="container lifeAtSalaam">
      <div className="row lifeCards">
        <h2>Certification 2026</h2>

        {items.length === 0 ? (
          <div className="col-sm-12">
            <p style={{ marginBottom: 0 }}>
              Certificates will be added here.
            </p>
          </div>
        ) : (
          <div className="col-sm-12">
            <Fade>
              <Swiper
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                loop={true}
                pagination={{ clickable: true }}
                slidesPerView={3}
                spaceBetween={20}
                breakpoints={{
                  0: { slidesPerView: 1, spaceBetween: 10 },
                  768: { slidesPerView: 2, spaceBetween: 15 },
                  992: { slidesPerView: 3, spaceBetween: 20 },
                }}
              >
                {items.map((src, idx) => (
                  <SwiperSlide key={`${src}-${idx}`}>
                    <img
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "cover",
                        borderRadius: 8,
                      }}
                      alt={`Certification 2026 ${idx + 1}`}
                      src={src}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </Fade>
          </div>
        )}
      </div>
    </div>
  );
};

export default Certification2026;

